import api from './api';

export const listVideos = ({ search = '', page = 1 } = {}) =>
  api.get('/admin/bunny-library', { params: { search, page } }).then(r => r.data);

export const setVideoThumbnail = (videoId, thumbnailUrl, imageAltText) =>
  api.put(`/admin/bunny-library/${videoId}/thumbnail`, { thumbnailUrl, imageAltText }).then(r => r.data);

export const renameVideo = (videoId, title) =>
  api.put(`/admin/bunny-library/${videoId}/title`, { title }).then(r => r.data);

export const addVideo = (title, sourceUrl) =>
  api.post('/admin/bunny-library', { title, sourceUrl }).then(r => r.data);

export const deleteVideo = (videoId) =>
  api.delete(`/admin/bunny-library/${videoId}`).then(r => r.data);
